import { getDynamicString, AxiosDynamicString } from "@ksxz/axios";
import { ExtraHeadersOptions } from "@ksxz/axios-plugins";
import { allowSetCustomHeaders } from "./utils";

export function createDefaultsExtraHeaders(
  csrftoken?: false | AxiosDynamicString,
  cid?: false | AxiosDynamicString,
  origin?: AxiosDynamicString
) {
  let headers: ExtraHeadersOptions = {};
  if (!csrftoken && !cid) return headers;
  if (csrftoken) {
    headers["x-csrftoken"] = function createCSRFTokenHeader(config) {
      const { service, method } = config;
      if (!service && !allowSetCustomHeaders(config, origin)) return;
      if (!method || !["post", "put", "delete"].includes(method)) return;
      return getDynamicString(config, csrftoken);
    };
  }
  if (cid) {
    headers["x-woa-client-id"] = function createClientIdHeader(config) {
      if (!allowSetCustomHeaders(config, origin)) return;
      return getDynamicString(config, cid);
    };
  }
  return headers;
}
